import { useEffect, useState } from "react";

const partners = [
  {
    id: 1,
    name: "الشريك الأول",
    logo: "/images/partners/partner-1.png",
  },
  {
    id: 2,
    name: "الشريك الثاني",
    logo: "/images/partners/partner-2.png",
  },
  {
    id: 3,
    name: "الشريك الثالث",
    logo: "/images/partners/partner-3.png",
  },
  {
    id: 4,
    name: "الشريك الرابع",
    logo: "/images/partners/partner-4.png",
  },
  {
    id: 5,
    name: "الشريك الخامس",
    logo: "/images/partners/partner-5.png",
  },
  {
    id: 6,
    name: "الشريك الخامس",
    logo: "/images/partners/partner-5.png",
  },
  {
    id: 7,
    name: "الشريك الخامس",
    logo: "/images/partners/partner-5.png",
  },
  {
    id: 8,
    name: "الشريك الخامس",
    logo: "/images/partners/partner-5.png",
  },
  {
    id: 9,
    name: "الشريك الخامس",
    logo: "/images/partners/partner-5.png",
  },
  {
    id: 10,
    name: "الشريك الخامس",
    logo: "/images/partners/partner-5.png",
  },
  {
    id: 11,
    name: "الشريك الخامس",
    logo: "/images/partners/partner-5.png",
  },
  {
    id: 12,
    name: "الشريك الخامس",
    logo: "/images/partners/partner-5.png",
  },
  {
    id: 13,
    name: "الشريك الخامس",
    logo: "/images/partners/partner-5.png",
  },
  {
    id: 14,
    name: "الشريك الخامس",
    logo: "/images/partners/partner-5.png",
  },
  {
    id: 15,
    name: "الشريك الخامس",
    logo: "/images/partners/partner-5.png",
  },
];

// شركاؤنا
export default function Partners() {
  const [current, setCurrent] = useState(0);

   useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % partners.length);
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const visiblePartners = [
    ...partners,
    ...partners,
  ];

  return (
    <>
      <section className="bg-white py-20 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

        {/* Header */}
        <div className="mx-auto mb-14 max-w-2xl text-center">
          <span className="mb-3 inline-block text-sm font-semibold text-green-600">
            شركاؤنا
          </span>

          <h2 className="text-3xl font-bold text-gray-900 md:text-4xl">
            شركاؤنا في النجاح
          </h2>

          <p className="mt-5 leading-8 text-gray-600">
            نعتز بشراكاتنا مع الجهات والمؤسسات التي تشاركنا
            رؤيتنا نحو مستقبل أكثر استدامة.
          </p>
        </div>

        {/* Slider */}
        <div className="relative overflow-hidden">

          <div
            className="flex transition-transform duration-700 ease-in-out"
            style={{
              transform: `translateX(-${current * 20}%)`,
            }}
          >
            {visiblePartners.map((partner, index) => (
              <div
                key={`${partner.id}-${index}`}
                className="
                  min-w-[50%]
                  px-2
                  sm:min-w-[33.333%]
                  md:min-w-[25%]
                  lg:min-w-[20%]
                "
              >
                <div
                  className="
                    flex
                    h-28
                    items-center
                    justify-center
                    rounded-xl
                    border
                    border-gray-100
                    bg-gray-50
                    px-6
                    transition
                    duration-300
                    hover:border-green-100
                    hover:bg-green-50/40
                  "
                >
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    className="
                      max-h-14
                      max-w-[140px]
                      object-contain
                      grayscale
                      opacity-60
                      transition
                      duration-300
                      hover:grayscale-0
                      hover:opacity-100
                    "
                  />
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </section>
    </>
  );
}
